import { c as _c } from "react/compiler-runtime";
import { getImageProps } from 'next/image';
import Typography from '@classify/react-core-components/Typography';
import Stack from '@classify/react-core-components/Stack';
import Avatar from '@classify/react-core-components/Avatar';
import type { CourseTeacher } from '@openclassrooms/sdk-web';
import isAllowedUrl from '@/modules/image/isAllowedUrl';
interface CourseTeachersProps {
  teachers: Array<CourseTeacher>;
}
const CourseTeachers = t0 => {
  const $ = _c(4);
  const {
    teachers
  } = t0;
  if (!teachers || teachers.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== teachers) {
    t1 = teachers.map(_temp);
    $[0] = teachers;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <>{t1}</>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default CourseTeachers;
function _temp(teacher) {
  let src = teacher.profilePicture;
  if (isAllowedUrl(src)) {
    const {
      props
    } = getImageProps({
      alt: "",
      width: 64,
      height: 64,
      src: teacher.profilePicture
    });
    src = props.src;
  }
  return <Stack direction="row" key={teacher.id} gap={2} sx={{
    maxWidth: 700
  }}><Avatar userId={teacher.id} userName={teacher.displayName} size="m" src={src} /><Stack direction="column" justifyContent="center"><Typography variant="h6" component="h4">{teacher.displayName}</Typography><Typography variant="body">{teacher.miniBiography}</Typography></Stack></Stack>;
}